import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import api from "../api";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../CustomSelect";
import "./simulazioni.css";
import useTrainerSearch from "../hooks/useTrainerSearch";

const AddSimulazioni = () => {
  const [trainerCodiceFiscale, setTrainerCodiceFiscale] = useState("");
  const [link, setLink] = useState("");
  const [inputErrors, setInputErrors] = useState({});
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const loadTrainerOptions = useTrainerSearch();

  const navigate = useNavigate();
  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "ADMIN") {
      alert("Accedi come amministratore per aggiungere una simulazione!");

      navigate("/login");
      localStorage.clear();
    } else {
      setIsAuthorized(true);
    }
  }, [navigate]);

  const isValid = () => {
    const errors = {};

    if (!trainerCodiceFiscale || trainerCodiceFiscale.length === 0) {
      errors.trainerCodiceFiscale = "Seleziona un docente!";
    }

    if (!link || link.trim().length < 5) {
      errors.link = "Il link deve contenere almeno 5 caratteri.";
    }

    setInputErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const addSimulazione = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      await api.post("/simulazioni", {
        trainerCodiceFiscale,
        link,
      });

      setTrainerCodiceFiscale("");
      setSelectedTrainer(null);
      setLink("");
      setInputErrors({});

      toast.success("Simulazione creata con successo!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      navigate("/simulazioni");
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  return (
    <div className="content-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="page-header">
        <div className="page-title">
          <i className="fa-solid fa-video"></i>
          Aggiungi Simulazione
        </div>
        <div className="controls">
          <button onClick={() => navigate("/simulazioni")} className="back-btn">
            <i className="fa-solid fa-arrow-left"></i>
            Torna alle Simulazioni
          </button>
        </div>
      </div>

      <div className="page-content simulazioni">
        <div className="form-card">
          <div className="card-header">
            <div className="card-title">
              <i className="fa-solid fa-clipboard-list"></i>
              Dettagli Simulazione
            </div>
            <div className="card-subtitle">
              Registra una nuova simulazione per un docente
            </div>
          </div>

          <div className="card-content">
            <div className="form-field">
              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-user-tie"></i>
                  Docente
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <CustomSelect
                    loadOptions={loadTrainerOptions}
                    value={selectedTrainer}
                    onChange={(selected) => {
                      setSelectedTrainer(selected);
                      const codiceFiscale =
                        selected?.trainer?.codiceFiscale ||
                        selected?.value ||
                        "";
                      setTrainerCodiceFiscale(codiceFiscale);
                      setInputErrors((prev) => ({
                        ...prev,
                        trainerCodiceFiscale: undefined,
                      }));
                    }}
                    placeholder="Seleziona un docente"
                    className="modern-select"
                  />
                  {inputErrors.trainerCodiceFiscale && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.trainerCodiceFiscale}
                    </span>
                  )}
                </div>
              </div>

              <div className="form-field">
                <label className="form-label">
                  <i className="fa-solid fa-link"></i>
                  Link alla Simulazione
                  <span className="required">*</span>
                </label>
                <div className="form-input">
                  <input
                    type="text"
                    value={link}
                    onChange={(e) => {
                      setLink(e.target.value);
                      setInputErrors((prev) => ({ ...prev, link: undefined }));
                    }}
                    className="modern-input"
                    placeholder="https://..."
                  />
                  {inputErrors.link && (
                    <span className="error-message">
                      <i className="fa-solid fa-exclamation-circle"></i>
                      {inputErrors.link}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button
                className="btn-secondary"
                onClick={() => navigate("/simulazioni")}
              >
                <i className="fa-solid fa-times"></i>
                Annulla
              </button>
              <button className="btn-primary" onClick={addSimulazione}>
                <i className="fa-solid fa-save"></i>
                Crea Simulazione
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSimulazioni;
